import React from "react";

import AOS from "aos";
import "aos/dist/aos.css";

function Works() {
  return (
    <div className="container mx-auto">
      {/* <div className="flex flex-col gap-20 px-4 py-20 bg-gray-200 mt-72"> */}
      <div className="flex flex-col gap-40 px-4 pb-52 pt-28 mt-72">
        {/* section1 */}
        <section className="flex flex-col items-center justify-center">
          <div className="flex text-4xl font-bold">
            <p className="text-main">코끼리협동조합</p>
            <p className="text-gray-800">은 어떤 일을 하나요?</p>
          </div>
        </section>
        {/* section2 */}
        {/* <section className="flex flex-col gap-10 bg-red-400"> */}
        <section className="flex flex-col gap-28">
          {/* 1 */}
          <div className="flex w-full">
            <p className="w-1/3 text-2xl font-semibold text-gray-800">
              | 메이커 스페이스 운영
            </p>
            <div className="flex flex-col w-2/3 gap-3">
              <p className="text-xl font-semibold text-gray-600">
                “메이커 스페이스란?”
              </p>
              <p className="text-base leading-6 text-gray-600">
                <p>
                  메이커 스페이스는 창작자들이 아이디어를 현실로 만들어낼 수 있는 공간입니다.
                </p>
                <p>
                  메이커 스페이스에는 창작에 필요한 다양한 도구가 준비되어 있으며
                  기술이나 지식이 부족하더라도 전문 메이커의 도움을 받아
                  원하는 작품을 만들어낼 수 있습니다.
                </p>
                <p>
                  코끼리 협동조합은 광주광역시 북구에 위치한 메이커 스페이스로 
                  지역 주민이나 학생들의 작품 제작, 스타트업의 시제품 제작과 컨설팅을 도와주고 있습니다.
                </p>
                <p>
                또한 교육, 워크숍, 메이커톤 등 다양한 프로그램을 운영하여 다양한 사람들과 커뮤니케이션 할 수 있는 공간과 기회를 제공하고 있습니다.
                </p>
                <p>
                  　
                </p>
              </p>
              <p className="text-xl font-semibold text-gray-600">
                “메이커 양성을 위한 다양한 교육 진행”
              </p>
              <p className="text-base leading-6 text-gray-600">
                <p>
                  코끼리 협동조합은 고등학생을 위한 청소년 주도 프로젝트, 3D프린터 운용 기능사 교육 등 지역 주민 및 학생들을 대상으로 메이커 교육을 진행하고 있습니다.
                </p>
                <p>
                  이외에도 고창행복원, 삼성꿈장학, 숭의고, 신안군 압해도 및 안좌도 등 다양한 곳으로 찾아가는 메이커 교육을 진행하고 있습니다.
                </p>
                <p>
                  　
                </p>
              </p>
              <p className="text-xl font-semibold text-gray-600">
                “재미있는 워크숍 진행”
              </p>
              <p className="text-base leading-6 text-gray-600">
                <p>
                  지역 주민과 학생, 그리고 전국 각지의 메이커들을 대상으로 다양한 주제의 재미있는 워크숍을 진행합니다.
                </p>
                <p>
                  칼림바 만들기, 무드등 만들기, 캠핑용품 메이킹 워크숍, 실크스크린 티셔츠 만들기 등 누구나 참여할 수 있는 다양한 주제의 워크숍을 진행하고 있습니다.
                </p>
                <p>
                  　
                </p>
              </p>
              <p className="text-xl font-semibold text-gray-600">
                “메이커를 위한 마라톤, 메이커톤 개최”
              </p>
              <p className="text-base leading-6 text-gray-600">
                <p>
                  · 오늘의집과 협업하여 전라남도 신안군에서 폐가구를 재활용하여 친환경 리사이클링 가구를 만드는 메이커톤
                </p>
                <p>
                  · 애견인 5명, 애묘인 5명이 모여 반려동물을 위해 직접 원목 하우스를 제작해 보는 반려동물 하우스 메이커톤
                </p>
                <p>
                  · 주방도구 제작 및 푸드해킹을 통해 다양한 식문화를 체험해보는 ㅋㅋ키친 메이커톤 등
                </p>
                <p>
                  　
                </p>
                <p>
                  코끼리 협동조합은 다양한 주제의 메이커톤을 지속적으로 개최하고 있습니다.
                </p>
              </p>
            </div>
          </div>

          {/* 2 */}
          <div className="flex w-full">
            <p className="w-1/3 text-2xl font-semibold text-gray-800">
              | 일상 문제 해결
            </p>
            <div className="flex flex-col w-2/3 gap-3">
              <p className="text-xl font-semibold text-gray-600">
                “일상 문제 해결이란?”
              </p>
              <p className="text-base leading-6 text-gray-600">
                <p>
                일상 문제 해결은 우리가 매일 마주하는 문제들을 해결하는 것을 의미합니다.
                </p>
                <p>
                이는 개인의 문제부터 시작하여 사회적, 지역사회적 문제에 이르기까지 다양합니다.
                </p>
                <p>
                코끼리 협동조합은 창의적이고 혁신적인 아이디어를 통해 이러한 문제들을 해결하고자 합니다.
                </p>
                <p>
                이 과정에서 우리는 다른 사람들과 협력하고 소통하며 새로운 기술을 배우고, 우리의 생활을 향상시키는 해결책을 찾습니다.
                </p>
                <p>
                  　
                </p>
              </p>
              <p className="text-xl font-semibold text-gray-600">
                “지역 소상공인 지원”
              </p>
              <p className="text-base leading-6 text-gray-600">
                <p>
                  오월첫동네 플리마켓, 구시청 나이트 페스티벌 등 지역 소상공인을 위한 다양한 행사를 진행하였습니다.
                </p>
                <p>
                  아시아 음식 문화거리 활성화 사업 운영 등 코끼리 협동조합은 다양한 방법으로 지역 내 소상공인을 지원하고 있습니다.
                </p>
                <p>
                  　
                </p>
              </p>
              <p className="text-xl font-semibold text-gray-600">
                “안전한 섬살이를 위한 선박 정보 안내 시스템”
              </p>
              <p className="text-base leading-6 text-gray-600">
                <p>
                  전라남도 신안군의 많은 섬들은 다리가 놓아져 있지 않아 선박을 통해서만 이동이 가능합니다.
                </p>
                <p>
                  하지만 선박이 결항인지, 아니면 몇 분 뒤에 도착하는지는 선사에 전화를 통해서만 알 수 있다는 문제점이 있었습니다.
                </p>
                <p>
                  코끼리 협동조합은 선박의 운항 정보를 수집하여 실시간으로 선박의 위치를 파악할 수 있는 시스템을 개발하였습니다.
                </p>
                <p>
                  모바일 앱은 물론 선착장에서 키오스크를 설치하여 누구나 편리하게 선박 결항여부 및 도착 시간을 확인할 수 있게 되었습니다.
                </p>
              </p>
            </div>
          </div>

          

          {/* 4 */}
          <div className="flex w-full">
            <p className="w-1/3 text-2xl font-semibold text-gray-800">
              | 창업 지원
            </p>
            <div className="flex flex-col w-2/3 gap-3">
              <p className="text-xl font-semibold text-gray-600">
                “지역 청년과 혁신적인 스타트업들을 위한 든든한 창업 지원”
              </p>
              <p className="text-base leading-6 text-gray-600">
                <p>
                  코끼리 협동조합은 마을기업, 제조업, 기획, IT 등 다양한 분야의 창업을 지원하고 있습니다.
                </p>
                <p>
                  지원 사업뿐만 아니라 수년간 쌓아온 네트워크를 통해 창업에 필요한 다양한 정보를 제공하고 맞춤형 컨설팅을 진행해 드립니다.
                </p>
                <p>
                  　
                </p>
              </p>
              <p className="text-xl font-semibold text-gray-600">
                “협동조합 창업지원”
              </p>
              <p className="text-base leading-6 text-gray-600">
                <p>
                  코끼리 협동조합은 2017년부터 7년간 총 39개의 협동조합 팀 창업을 지원하고 있습니다.
                </p>
                <p>
                  창업에 필요한 네트워크나 컨설팅 뿐만 아니라 지원사업을 통해 현실적으로 가장 필요한 창업자금을 지원해 드리고 있습니다.
                </p>
                <p>
                  　
                </p>
              </p>
              <p className="text-xl font-semibold text-gray-600">
                “2023년 지역 주민 창업지원”
              </p>
              <p className="text-base leading-6 text-gray-600">
                <p>
                  코끼리 협동조합은 매 년 지역 주민 창업을 지원하고 있습니다. 2023년 창업 지원 사업은 다음과 같습니다.
                </p>
                <p>
                  · 아시아 음식 문화거리 활성화 사업을 통해 총 5개의 지역 주민 창업을 지원하였습니다.
                </p>
                <p>
                  · 실무형 문화기획 전문학교 `호랭이스쿨`을 통해 총 12명의 문화기획가를 양성하였습니다.
                </p>
                <p>
                  　
                </p>
              </p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

AOS.init();
export default Works;
